// Shared reasoning-mode catalog + persistence for the composer and sidebar.
import { REASONING_MODE_LABELS } from "./SidebarTopBar";

export const REASONING_OPTIONS = [
  {
    value: "standard",
    label: REASONING_MODE_LABELS.standard,
    description: "Quickest answers",
    command: "fast",
  },
  {
    value: "extended",
    label: REASONING_MODE_LABELS.extended,
    description: "Balanced speed and depth",
    command: "standard",
  },
  {
    value: "deep",
    label: REASONING_MODE_LABELS.deep,
    description: "Reasons longer before answering",
    command: "deep-thinking",
  },
  {
    value: "max",
    label: REASONING_MODE_LABELS.max,
    description: "Highest reasoning effort on every answer",
    command: "max",
  },
];

export const reasoningLabelFor = (mode) =>
  REASONING_OPTIONS.find((option) => option.value === mode)?.label ??
  REASONING_OPTIONS[0].label;

export const REASONING_SHORT_LABELS = Object.freeze({
  standard: "Fast",
  extended: "Standard",
  deep: "Deep",
  max: "MAX",
});

export const reasoningShortLabelFor = (mode) =>
  REASONING_SHORT_LABELS[mode] || reasoningLabelFor(mode);

// Persists the mode server-side and returns the mode the backend accepted.
// Throws on any failure so callers can revert optimistic UI.
export const persistReasoningMode = async (mode) => {
  const res = await fetch("/graphql", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      query: `
        mutation ($reasoningMode: String!) {
          updateUserReasoningMode(reasoningMode: $reasoningMode) {
            status
            reasoningMode
          }
        }
      `,
      variables: { reasoningMode: mode },
    }),
  });
  const json = await res.json();
  const payload = json?.data?.updateUserReasoningMode;
  if (!payload || payload.status !== "200") {
    throw new Error(payload?.error || "Save failed");
  }
  return payload.reasoningMode || mode;
};
